import React, { useState, useEffect } from "react";
import { Bracket, Seed, SeedItem, SeedTeam } from "react-brackets";
import styled from "styled-components";
import ScrollContainer from "react-indiana-drag-scroll";
import Modal from "./Modal";
import { ReactComponent as StartGameIcon } from "../img/icons/playGame.svg";
import { ReactComponent as EndGameIcon } from "../img/icons/endGame.svg";
import startGameIcon from "../img/icons/playGame.svg";
import endGameIcon from "../img/icons/endGame.svg";
import Button from "./Button";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import FinalMatch from "./FinalMatch.js";

window.admin = false;

export const SeedStyle = styled(Seed)`
  font-size: 12px;
  :after,
  :before {
    border-color: ${(props) => props.theme.color.border} !important;
  }
`;
export const SeedItemStyle = styled(SeedItem)`
  background: transparent;
  box-shadow: none;
`;
export const SeedTeamStyle = styled(SeedTeam)`
  color: ${({ theme, playing }) => (playing ? theme.color.background : theme.color.primaryText)};
  font-family: "Poppins Medium";
  font-size: 14px;
  background: ${({ theme, playing }) =>
    playing ? theme.color.primaryText : theme.color.secondaryBg};
  min-height: 40px;
  height: auto;
  padding: 6px 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: visible;
  margin-bottom: ${({ first }) => (first ? "2px" : "0")};
  border-radius: ${({ first }) => (first ? "4px 4px 0 0" : "0 0 4px 4px")};
  opacity: ${({ winner, finished }) => (!winner && finished ? "0.5" : "1")};
`;

export const TeamMeta = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const TeamName = styled.div`
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TeamRoster = styled.div`
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.1;
  color: ${({ theme }) => theme.color.lighterText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Score = styled.input.attrs({
  min: "0",
})`
  font-family: "Poppins Medium";
  margin-left: auto;
  margin-right: 2px;
  font-size: 14px;
  text-align: right;
  width: 50%;
  padding-right: 5px;
  background-color: transparent;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  [type="number"] {
    -moz-appearance: textfield;
  }
`;
export const Flag = styled.img`
  margin-right: 6px;
  max-width: 18px;
  height: 18px;
  width: 18px;
  border-radius: 50px;
  background-color: ${({ theme }) => theme.color.secondaryBg};
`;
export const TBA = styled.p`
  margin: auto;
  width: "100%";
  font-family: "Poppins Medium";
  font-size: 12px;
  cursor: ${({ admin }) => (admin ? "pointer" : "default")};
`;
export const PlayersList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  background: ${({ theme }) => theme.color.background};
  bottom: ${({ down }) => (down ? "" : "109%")};
  top: ${({ down }) => (down ? "109%" : "")};
  left: 0;
  z-index: 4;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.border};
  max-height: 180px;
  overflow: auto;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);
`;
export const PlayerItem = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 5px;
  width: 100%;
  background: ${({ theme }) => theme.color.background};
  padding: 5px;
  cursor: default;
  color: ${({ theme }) => theme.color.primaryText};
  :hover {
    background: ${({ theme }) => theme.color.secondaryBg};
  }
`;

export const getRosterNames = (player) => {
  if (!player || typeof player !== "object") return [];

  const normalize = (m) => {
    if (!m) return null;
    if (typeof m === "string" || typeof m === "number") return String(m);
    if (typeof m === "object") {
      return (
        m.username ||
        m.name ||
        m.displayName ||
        m.label ||
        (m.user && (m.user.username || m.user.name)) ||
        (m.player && (m.player.username || m.player.name)) ||
        null
      );
    }
    return null;
  };

  const candidates = [
    player.memberUsers,
    player.members,
    player.teamMembers,
    player.team,
    player.players,
    player.roster,
    player.participants,
  ];

  const raw = candidates.find((x) => Array.isArray(x) && x.length > 0);
  if (!raw) return [];

  const names = raw.map(normalize).filter(Boolean);
  return Array.from(new Set(names));
};
export const ManageMatch = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 4;
  top: 0;
  height: 6px;
`;
// export const getLastRoundPlayer = (roundIndex, part, indexOfSeed) => {
//   export const round = rounds[roundIndex - 1];
//   return round.seeds[indexOfSeed * 2 + part];
// };
export const editScore = (info) => {
  info.team.score = info.score;
};
export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 44px;
`;
export const ModalIcon = styled.img`
  width: 54px;
  height: 54px;
  margin-bottom: 18px;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Description = styled.p`
  font-family: "PT Serif";
  font-size: 16px;
  color: ${({ theme }) => theme.color.lighterText};
`;
export const Footer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Buttons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 31px;
`;

const HandleConfirm = ({ hideModal, action, seed }) => {
  const description = () => {
    if (action === "Start") {
      return (
        "Start the game between " +
        seed.teams[0].player.name.toUpperCase() +
        " and " +
        seed.teams[1].player.name.toUpperCase() +
        " ?"
      );
    } else if (action === "End" && seed.teams[0].score !== seed.teams[1].score)
      return (
        "End the game between " +
        seed.teams[0].player.name.toUpperCase() +
        " and " +
        seed.teams[1].player.name.toUpperCase() +
        " ?"
      );
    else if (action === "End" && seed.teams[0].score === seed.teams[1].score) {
      return "Score is equal!";
    } else if (action === "Select") {
      return "Select this Team ?";
    }
  };
  const title = action === "Select" ? "Select player" : action + " The game";
  const buttonText = action === "Select" ? action : action + " game";
  const { id } = useParams();
  return (
    <ModalContainer>
      <Header>
        <ModalIcon src={action === "End" ? endGameIcon : startGameIcon} />
        <h4>{title}</h4>
      </Header>
      <Footer>
        <Description>{description()}</Description>
      </Footer>
      <Buttons>
        <Button size="small" onClick={hideModal}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="primary"
          onClick={async () => {
            let winnerID = 0;
            let matchID = seed.id;
            let scorePlayer1 = 0;
            let scorePlayer2 = 0;
            if (action === "Start") {
              seed.playing = true;
              seed.finished = false;
              seed.teams[0].score = "0";
              seed.teams[1].score = "0";
              if (seed.playing) seed.finished = false;
              axios
                .post(process.env.REACT_APP_START_MATCH_ENDPOINT + matchID, {
                  withCredentials: true,
                })
                .then((x) => { });
            } else if (action === "End" && seed.teams[0].score !== seed.teams[1].score) {
              matchID = seed.id;
              if (seed.teams[0].score > seed.teams[1].score) {
                // rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[0].player;
                winnerID = seed.teams[0].playerID;
                // if ((roundIndex )!= (rounds.length)) rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[0].player;
              }
              if (seed.teams[0].score < seed.teams[1].score) {
                // rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[1].player;
                winnerID = seed.teams[1].playerID;
                // if ((roundIndex )!= (rounds.length)) rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[1].player;
              }
              scorePlayer1 = seed.teams[0].score;
              scorePlayer2 = seed.teams[1].score;
              try {
                console.log("WinnerId");
                console.log(winnerID);
                if (isNaN(scorePlayer1)) scorePlayer1 = parseInt(0);
                if (isNaN(scorePlayer2)) scorePlayer2 = parseInt(0);
                seed.finished = true;
                seed.playing = false;
                await axios.post(
                  process.env.REACT_APP_TOURNAMENT_SET_WINNER_ENDPOINT,
                  { matchID, winnerID, tournmentID: id, scorePlayer1, scorePlayer2 },
                  { withCredentials: true }
                );
              } catch (err) {
                console.log(err);
              }
              if (seed.finished) seed.playing = false;
            }
            hideModal();
          }}
        >
          {action === "End"
            ? seed.teams[0]?.score === seed.teams[1]?.score
              ? ""
              : buttonText
            : buttonText}
        </Button>
      </Buttons>
    </ModalContainer>
  );
};

export const CustomSeed = ({ seed, breakpoint, roundIndex, seedIndex }) => {
  const rounds = useSelector((state) => state.rounds.data);
  const admin = window.admin;
  const history = useHistory();
  const { slug } = useParams();
  const [confirmModal, setConfirmModal] = useState(false);
  const [newScore, setNewScore] = useState({ score: parseInt(0), team: null });
  const [checkVal, setCheckVal] = useState();
  const hideModal = () => setConfirmModal(false);

  const canNavigateToMatch = !admin && !!slug && !!seed?.id;
  const handleOpenMatch = () => {
    if (!canNavigateToMatch) return;
    history.push(`/events/${slug}/match/${seed.id}`);
  };

  // console.log(seed)
  // console.log(rounds);
  // console.log(dummyRounds);
  useEffect(() => {
    if (newScore.team) editScore(newScore);
  }, [newScore]);
  if (!rounds || rounds.length === 0) return <div />;
  else
    return (
      <SeedStyle mobileBreakpoint={breakpoint}>
        {admin ? (
          <Modal isOpen={confirmModal} onRequestClose={hideModal} hideModal={hideModal}>
            <HandleConfirm
              hideModal={hideModal}
              roundIndex={roundIndex}
              seedIndex={seedIndex}
              action={checkVal}
              seed={seed}
            />
          </Modal>
        ) : (
          ""
        )}
        <SeedItemStyle
          onClick={handleOpenMatch}
          style={{ cursor: canNavigateToMatch ? "pointer" : "default" }}
        >
          {admin && seed.teams[0]?.player && seed.teams[1]?.player ? (
            <ManageMatch>
              {!rounds[roundIndex].seeds[seedIndex].playing &&
                !rounds[roundIndex].seeds[seedIndex].finished ? (
                <Button
                  style={{ margin: "0 auto 4px" }}
                  icon
                  onClick={() => {
                    console.log(seed);
                    setCheckVal("Start");
                    setConfirmModal(true);
                  }}
                >
                  <StartGameIcon />
                </Button>
              ) : (
                ""
              )}
              {seed.playing && !seed.finished ? (
                <Button
                  style={{ margin: "0 auto 4px" }}
                  icon
                  onClick={() => {
                    setCheckVal("End");
                    setConfirmModal(true);
                  }}
                >
                  <EndGameIcon />
                </Button>
              ) : (
                ""
              )}
            </ManageMatch>
          ) : (
            ""
          )}
          <div>
            <SeedTeamStyle
              finished={seed.finished}
              playing={seed.playing}
              first={true}
              winner={seed.teams[0].score >= seed.teams[1].score}
            >
              {seed.teams[0]?.player ? (
                <>
                  {seed.teams[0].player.avatar ? <Flag src={seed.teams[0].player.avatar} alt="" /> : null}
                  <TeamMeta>
                    <TeamName>{seed.teams[0]?.player.name}</TeamName>
                    {getRosterNames(seed.teams[0]?.player).length > 0 && (
                      <TeamRoster>{getRosterNames(seed.teams[0]?.player).join(", ")}</TeamRoster>
                    )}
                  </TeamMeta>
                  <Score
                    disabled={seed.finished || !admin || (!seed.finished && !seed.playing)}
                    value={parseInt(seed.teams[0].score) || parseInt(0)}
                    type="number"
                    onChange={(e) => {
                      seed.teams[0].score = parseInt(e.target.value);
                      console.log(typeof parseInt(e.target.value));
                      setNewScore({
                        score: parseInt(e.target.value),
                        team: seed.teams[0],
                      });
                    }}
                  />
                </>
              ) : (
                <TBA admin={admin}>{admin ? "SELECT" : "TBA"}</TBA>
              )}
            </SeedTeamStyle>
            <SeedTeamStyle
              finished={seed.finished}
              playing={seed.playing}
              winner={seed.teams[0].score <= seed.teams[1].score}
            >
              {seed.teams[1]?.player ? (
                <>
                  {seed.teams[1].player.avatar ? <Flag src={seed.teams[1].player.avatar} alt="" /> : null}
                  <TeamMeta>
                    <TeamName>{seed.teams[1]?.player.name}</TeamName>
                    {getRosterNames(seed.teams[1]?.player).length > 0 && (
                      <TeamRoster>{getRosterNames(seed.teams[1]?.player).join(", ")}</TeamRoster>
                    )}
                  </TeamMeta>
                  <Score
                    disabled={seed.finished || !admin || (!seed.finished && !seed.playing)}
                    value={parseInt(seed.teams[1].score) || parseInt(0)}
                    type="number"
                    onChange={(e) => {
                      seed.teams[1].score = parseInt(e.target.value);
                      console.log(typeof parseInt(e.target.value));
                      setNewScore({
                        score: parseInt(e.target.value),
                        team: seed.teams[1],
                      });
                    }}
                  />
                </>
              ) : (
                <TBA admin={admin}>{admin ? "SELECT" : "TBA"}</TBA>
              )}
            </SeedTeamStyle>
          </div>
        </SeedItemStyle>
      </SeedStyle>
    );
};

const SingleElimination = () => {
  let stream = true;
  const [singleRounds, setSingleRounds] = useState([]);
  const rounds = useSelector((state) => state.rounds.data);
  const adminId = useSelector((state) => state.rounds.adminId);
  const [winner, setWinner] = useState(null);
  const userId = useSelector((state) => state.user.data._id);
  console.log(userId);
  useEffect(() => {
    if (rounds !== undefined && rounds && rounds?.length) {
      let player0 = rounds[rounds?.length - 1]?.seeds[0]?.teams[0];
      let player1 = rounds[rounds?.length - 1]?.seeds[0]?.teams[1];
      let finished = rounds?.length ? rounds[rounds?.length - 1]?.seeds[0]?.finished : 0;
      console.log(player0, player1);
      setSingleRounds(rounds);
      window.admin = userId === adminId && !stream;
      setWinner(
        rounds?.length && finished
          ? player0?.score > player1?.score
            ? player0?.player
            : player1?.player
          : null
      );
    }
  }, [rounds, adminId, userId, stream]);
  console.log(singleRounds);
  return (
    <ScrollContainer horizontal={true} vertical={true} style={{ padding: "10px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {singleRounds?.length ? (
          <Bracket mobileBreakpoint={0} rounds={singleRounds} renderSeedComponent={CustomSeed} />
        ) : (
          <></>
        )}
        {winner ? (
          <FinalMatch teams={singleRounds[singleRounds.length - 1]?.seeds[0]?.teams} />
        ) : (
          <></>
        )}
      </div>
    </ScrollContainer>
  );
};

export default SingleElimination;
